import React, { useEffect, useState } from "react";
import { StaffSideMenu } from "../staff/StaffSideMenu";
import API_URL from "../../api/API";
import { useStaffAuthContext } from "../staff/useStaffAuthContext";
import { Link, useNavigate } from "react-router-dom";

export const AdminCreateStrengthExercise = () => {
  const { staff } = useStaffAuthContext();
  const navigate = useNavigate();  // Initialize navigate function

  const [title, setTitle] = useState(""); // State to store the title
  const [instructions, setInstructions] = useState(""); // State to store the description
  const [video_url, setVideoUrl] = useState(""); // State to store the video URL
  const [isLoading, setIsLoading] = useState(false); // State to manage loading
  const [error, setError] = useState(""); // State to store error messages
  const [successMessage, setSuccessMessage] = useState(""); // State to store success message

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Clear any existing errors
    setSuccessMessage(""); // Clear any existing success messages
    setIsLoading(true); // Start loading

    try {
      const response = await fetch(`${API_URL.POST_CREATE_STRENGTH_EXERCISE}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff.token}`, // Include authentication token
        },
        body: JSON.stringify({ title, instructions, video_url }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || "Failed to create exercise");
      }

      setSuccessMessage("Exercise created successfully!");
      setTitle(""); // Clear the form
      setInstructions("");
      setVideoUrl("");
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const handleGoBack = () => {
    navigate(-1); // Navigate back to the previous page
  };

  return (
    <div className="flex h-screen">
      <StaffSideMenu />

      {/* Main Content */}
      <div className="flex-1 p-6 bg-gray-100 pt-16">
         <div className="absolute top-4 right-4">
              <button
                onClick={handleGoBack}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
              >
                Go Back
              </button>
            </div>

        <h1 className="text-2xl font-bold mb-6">Create Strength Exercise</h1>

        <div className="flex space-x-8">
          {/* Form Section */}
          <div className="flex-1">
            <form
              onSubmit={handleSubmit}
              className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 max-w-lg mx-auto"
            >
              {/* Title Input */}
              <div className="mb-4">
                <label
                  htmlFor="title"
                  className="block text-gray-700 text-sm font-bold mb-2"
                >
                  Exercise Title*
                </label>
                <input
                  type="text"
                  id="title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="Enter exercise title"
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  required
                />
              </div>

              {/* Instructions Input (Converted to Textarea) */}
              <div className="mb-4">
                <label
                  htmlFor="instructions"
                  className="block text-gray-700 text-sm font-bold mb-2"
                >
                  Exercise Instructions*
                </label>
                <textarea
                  id="instructions"
                  value={instructions}
                  onChange={(e) => setInstructions(e.target.value)}
                  placeholder="Enter exercise instructions"
                  rows="5"
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  required
                />
              </div>

              {/* Video Input */}
              <div className="mb-4">
                <label
                  htmlFor="video_url"
                  className="block text-gray-700 text-sm font-bold mb-2"
                >
                  YouTube Video URL:
                </label>
                <input
                  type="text"
                  id="video_url"
                  value={video_url}
                  onChange={(e) => setVideoUrl(e.target.value)}
                  placeholder="Enter YouTube embed URL"
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>

              {/* Error Message */}
              {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

              {/* Success Message */}
              {successMessage && (
                <p className="text-green-500 text-sm mb-4">{successMessage}</p>
              )}

              {/* Submit Button */}
              <div className="flex items-center justify-between">
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`${
                    isLoading ? "bg-blue-300" : "bg-blue-500 hover:bg-blue-700"
                  } text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline`}
                >
                  {isLoading ? "Creating..." : "Create Exercise"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
